import { useFlexSize } from "@react-three/flex"
import { useLayoutEffect } from "react"


function PagePosition({ onReflow }) {
  const size = useFlexSize();
  useLayoutEffect(() => onReflow && onReflow(...size), [onReflow, size])
  return null
};

export default PagePosition